import React, { useContext, useMemo, useCallback } from 'react';

import clsx from 'clsx';
import { Point, DivIcon, LatLngExpression } from 'leaflet';
import { Marker as LeafletMarker } from 'react-leaflet';

import { ClusterPointer } from '@api/types/shared';

import { MapContext } from '@contexts/map-context/map-context';

import classes from './cluster-marker.module.scss';

const getIcon: (cluster: ClusterPointer, classes: any, zoom: number) => any = (
  cluster,
  classes,
  zoom,
) => {
  let size = 40;
  let fontSizeLarge = false;

  if (zoom < 15) {
    if (cluster.amount > 10) {
      size = 50;
    }

    if (cluster.amount > 100) {
      size = 60;
    }

    if (cluster.amount > 1000) {
      size = 80;
      fontSizeLarge = true;
    }
  } else {
    if (cluster.amount > 10) {
      size = 50;
    }
    if (cluster.amount > 100) {
      size = 80;
      fontSizeLarge = true;
    }
  }

  return new DivIcon({
    html:
      `<div class='${classes.clusterMarker__divIconHtml}'><span>` +
      cluster.amount +
      `</span></div>`,
    className: clsx(
      classes.clusterMarker__divIcon,
      fontSizeLarge && classes['clusterMarker--sizeLarge'],
    ),
    iconSize: new Point(size, size),
    iconAnchor: [21 / 2, 21 / 2],
  });
};

interface ClusterMarkerProps {
  clusterPointer: ClusterPointer;
  showActualPoint?: boolean;
  onClick?: () => void;
}

export const ClusterMarker = ({
  clusterPointer,
  showActualPoint,
  onClick: onClickProp,
}: ClusterMarkerProps) => {
  const { zoomTo, zoom } = useContext(MapContext);

  const { point, actualPoint } = clusterPointer;
  const { geohash } = clusterPointer;
  const coordinates =
    geohash.length < 4 || showActualPoint
      ? actualPoint.coordinates
      : point.coordinates;
  const position: LatLngExpression = [coordinates[1], coordinates[0]];

  const icon = useMemo(
    () => getIcon(clusterPointer, classes, zoom),
    [clusterPointer, zoom],
  );

  const onClick = useCallback(() => {
    zoomTo(
      [
        clusterPointer.actualPoint.coordinates[1],
        clusterPointer.actualPoint.coordinates[0],
      ],
      zoom > 11 ? zoom + 1 : zoom + 2,
    );

    if (onClickProp) onClickProp();
  }, [zoom, zoomTo, clusterPointer]);

  return (
    <LeafletMarker
      icon={icon}
      position={position}
      onClick={onClick}
    ></LeafletMarker>
  );
};
